/**
 * Registers the app-shell service worker.
 *
 * Without a registered worker the offline itinerary feature cannot work at all:
 * a saved snapshot sits in IndexedDB, but with no cached shell the browser has
 * nothing to load to reach it.
 *
 * Off in development by default, where a cached shell mostly serves to hide the
 * change you just made. Set REACT_APP_ENABLE_SW=true to test offline locally.
 */

const shouldRegister = () =>
  process.env.REACT_APP_ENABLE_SW === 'true' || process.env.NODE_ENV === 'production';

export default function registerServiceWorker() {
  if (typeof window === 'undefined' || !('serviceWorker' in navigator)) return;
  if (!shouldRegister()) return;

  // Registering after load keeps the worker off the critical path for a
  // first-time visitor, who gains nothing from it on this visit anyway.
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js', { scope: '/' }).catch((error) => {
      console.warn('[SW] Registration failed:', error.message);
    });
  }, { once: true });
}

/**
 * Drops the worker's fallback copies of trip reads.
 *
 * Called on sign-out. Nothing depends on it having finished — the cache is keyed
 * on the credential that filled it, so the next person to sign in cannot read it
 * either way — which is why this resolves quietly rather than reporting failure.
 */
export function clearOfflineApiCache() {
  if (typeof navigator === 'undefined' || !('serviceWorker' in navigator)) {
    return Promise.resolve();
  }

  return navigator.serviceWorker.ready
    .then((registration) => {
      registration.active?.postMessage({ type: 'CLEAR_API_CACHE' });
    })
    .catch(() => {});
}
